import { render, staticRenderFns } from "./UserRolesSection.vue?vue&type=template&id=5aaf36de"
import script from "./UserRolesSection.vue?vue&type=script&lang=js"
export * from "./UserRolesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports